// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PanelItem-listContainer-uJG01 {
  padding-left: 0px;
  margin: 0px;
  list-style-type: none;
}

.PanelItem-listContainer-uJG01 .PanelItem-panelBody-GTMTP:first-child {
  padding-top: 0px;
}

.PanelItem-listContainer-uJG01 .PanelItem-panelBody-GTMTP:last-child {
  border-bottom: 0px;
  padding-bottom: 0px;
}

.PanelItem-linkCss-VCeKk {
  padding: 10px 20px !important;
}

.PanelItem-plusIcon-ALSbh {
  margin: 0px 6px 2px 0px;
  width: 100%;
  max-width: 14px;
}

.PanelItem-listFlex-mWGTA {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
  margin: 30px 0 24px;
}

.PanelItem-noListHeading-ojBkP {
  font-size: 20px;
  margin: 19px 0 10px;
}

.PanelItem-noListSubHeading-bCuWs {
  color: var(--common-text-Secondry-color);
}

.PanelItem-textCenter-Ry0df {
  text-align: center;
}

.PanelItem-addNewBtn-ICgyy {
  padding: 13px 15px;
  margin-top: 30px;
  display: inline-block;
}

.PanelItem-noMargin-NLLg6 {
  margin: 0;
}

.PanelItem-btnMinWidth-nEUpS {
  min-width: 131px;
}

@media screen and (max-width: 767px) {
  .PanelItem-listFlex-mWGTA {
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    margin-top: 15px;
    margin-bottom: 15px;
  }

  .PanelItem-mobileSearchWidth-TnDl4 {
    width: 100%;
  }

  .PanelItem-linkCss-VCeKk {
    display: block;
    text-align: center;
    margin-top: 15px;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/ManageListing/PanelItem/PanelItem.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAIA;EACE;IACE,mBAAe;QAAf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;EAClB;;AAEF","sourcesContent":[".listContainer {\n  padding-left: 0px;\n  margin: 0px;\n  list-style-type: none;\n}\n\n.listContainer .panelBody:first-child {\n  padding-top: 0px;\n}\n\n.listContainer .panelBody:last-child {\n  border-bottom: 0px;\n  padding-bottom: 0px;\n}\n\n.linkCss {\n  padding: 10px 20px !important;\n}\n\n.plusIcon {\n  margin: 0px 6px 2px 0px;\n  width: 100%;\n  max-width: 14px;\n}\n\n.listFlex {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  margin: 30px 0 24px;\n}\n\n.noListHeading {\n  font-size: 20px;\n  margin: 19px 0 10px;\n}\n\n.noListSubHeading {\n  color: var(--common-text-Secondry-color);\n}\n\n.textCenter {\n  text-align: center;\n}\n\n.addNewBtn {\n  padding: 13px 15px;\n  margin-top: 30px;\n  display: inline-block;\n}\n\n.noMargin {\n  margin: 0;\n}\n\n.btnMinWidth {\n  min-width: 131px;\n}\n\n\n\n@media screen and (max-width: 767px) {\n  .listFlex {\n    flex-wrap: wrap;\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n\n  .mobileSearchWidth {\n    width: 100%;\n  }\n\n  .linkCss {\n    display: block;\n    text-align: center;\n    margin-top: 15px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listContainer": `PanelItem-listContainer-uJG01`,
	"panelBody": `PanelItem-panelBody-GTMTP`,
	"linkCss": `PanelItem-linkCss-VCeKk`,
	"plusIcon": `PanelItem-plusIcon-ALSbh`,
	"listFlex": `PanelItem-listFlex-mWGTA`,
	"noListHeading": `PanelItem-noListHeading-ojBkP`,
	"noListSubHeading": `PanelItem-noListSubHeading-bCuWs`,
	"textCenter": `PanelItem-textCenter-Ry0df`,
	"addNewBtn": `PanelItem-addNewBtn-ICgyy`,
	"noMargin": `PanelItem-noMargin-NLLg6`,
	"btnMinWidth": `PanelItem-btnMinWidth-nEUpS`,
	"mobileSearchWidth": `PanelItem-mobileSearchWidth-TnDl4`
};
module.exports = ___CSS_LOADER_EXPORT___;
